import { render } from "./AboutUs.vue?vue&type=template&id=f313a33e&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=f313a33e&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f313a33e"]])

export default __exports__